var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeCloseGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4160_11271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.749756,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4160_11271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8498 13.3L15.3998 11.85C15.5498 11.0667 15.3248 10.3334 14.7248 9.65005C14.1248 8.96672 13.3498 8.70005 12.3998 8.85005L10.9498 7.40005C11.2331 7.26672 11.5206 7.16672 11.8123 7.10005C12.1039 7.03338 12.4164 7.00005 12.7498 7.00005C13.9998 7.00005 15.0623 7.43755 15.9373 8.31255C16.8123 9.18755 17.2498 10.25 17.2498 11.5C17.2498 11.8334 17.2164 12.1459 17.1498 12.4375C17.0831 12.7292 16.9831 13.0167 16.8498 13.3ZM20.0498 16.4501L18.5998 15.05C19.2331 14.5667 19.7956 14.0376 20.2873 13.4626C20.7789 12.8876 21.1998 12.2334 21.5498 11.5C20.7164 9.81672 19.5206 8.47922 17.9623 7.48755C16.4039 6.49588 14.6664 6.00005 12.7498 6.00005C12.2664 6.00005 11.7914 6.03338 11.3248 6.10005C10.8581 6.16672 10.3998 6.26672 9.94976 6.40005L8.39976 4.85005C9.08309 4.56672 9.78309 4.35422 10.4998 4.21255C11.2164 4.07088 11.9664 4.00005 12.7498 4.00005C15.2664 4.00005 17.5081 4.69588 19.4748 6.08755C21.4414 7.47922 22.8664 9.28338 23.7498 11.5C23.3664 12.4834 22.8623 13.3959 22.2373 14.2375C21.6123 15.0792 20.8831 15.8167 20.0498 16.4501ZM20.5498 22.6L16.3498 18.4501C15.7664 18.6334 15.1789 18.7709 14.5873 18.8626C13.9956 18.9542 13.3831 19 12.7498 19C10.2331 19 7.99142 18.3042 6.02476 16.9125C4.05809 15.5209 2.63309 13.7167 1.74976 11.5C2.09976 10.6167 2.54142 9.79588 3.07476 9.03755C3.60809 8.27922 4.21642 7.60005 4.89976 7.00005L2.14976 4.20005L3.54976 2.80005L21.9498 21.2001L20.5498 22.6ZM6.29976 8.40005C5.81642 8.83338 5.37476 9.30838 4.97476 9.82505C4.57476 10.3417 4.23309 10.9 3.94976 11.5C4.78309 13.1834 5.97892 14.5209 7.53726 15.5126C9.09559 16.5042 10.8331 17.0001 12.7498 17.0001C13.0831 17.0001 13.4081 16.9792 13.7248 16.9376C14.0414 16.8959 14.3664 16.85 14.6998 16.8L13.7998 15.85C13.6164 15.9 13.4414 15.9376 13.2748 15.9626C13.1081 15.9876 12.9331 16 12.7498 16C11.4998 16 10.4373 15.5625 9.56226 14.6875C8.68726 13.8125 8.24976 12.75 8.24976 11.5C8.24976 11.3167 8.26226 11.1417 8.28726 10.975C8.31226 10.8084 8.34976 10.6334 8.39976 10.45L6.29976 8.40005Z",
    fill: "#A1A1AA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseGray);
export default __webpack_public_path__ + "static/media/Eye-close-gray.f770ecae4f972397f678fbdad9afbc9c.svg";
export { ForwardRef as ReactComponent };